module.exports = app => {
  const controllers = {};
  return controllers;
};
